import { Panel, PanelProps } from "capitalrx-components-2.0/lib/general";
import { PropsWithChildren } from "react";
import styled from "styled-components";

export const StyledCard = styled(Panel)<{ $noPadding?: boolean, $fullHeight?: boolean }>`
  height: ${(props) => props.$fullHeight ? "100%" : null};
  padding: ${(props) => props.$noPadding ? "0!important" : null};
`;

export const Card = (props: PropsWithChildren<PanelProps & { noPadding?: boolean; fullHeight?: boolean }>) => {
  const { children, noPadding, fullHeight } = props;
  return <StyledCard $noPadding={noPadding} $fullHeight={fullHeight}>{children}</StyledCard>;
};
